<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="medium">
    <div class="column content-box">
      <woot-modal-header
        :header-title="$t('CAMPAIGN_FLOW.QUOTATION.TITLE')"
        :header-content="$t('CAMPAIGN_FLOW.QUOTATION.DESC')"
      />
      <form class="row" @submit.prevent="onSave">
        <div class="medium-12 columns">
          <label>
            {{ $t('CAMPAIGN_FLOW.QUOTATION.PLAN.LABEL') }}
            <select v-model="selectedPlanId" :disabled="isLoading">
              <option value="" disabled>
                {{
                  isLoading
                    ? $t('CAMPAIGN_FLOW.QUOTATION.PLAN.LOADING')
                    : $t('CAMPAIGN_FLOW.QUOTATION.PLAN.PLACEHOLDER')
                }}
              </option>
              <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                {{ plan.nome }}
              </option>
            </select>
          </label>
          <p v-if="!isLoading && !plans.length" class="help-text error">
            {{ $t('CAMPAIGN_FLOW.QUOTATION.PLAN.EMPTY') }}
          </p>

          <label>
            {{ $t('CAMPAIGN_FLOW.QUOTATION.PLATE_FIELD.LABEL') }}
            <input
              v-model.trim="selectedPlateField"
              type="text"
              :placeholder="
                $t('CAMPAIGN_FLOW.QUOTATION.PLATE_FIELD.PLACEHOLDER')
              "
            />
          </label>
          <p class="help-text">
            {{ $t('CAMPAIGN_FLOW.QUOTATION.PLATE_FIELD.HELP') }}
          </p>

          <quotation-tags />

          <div class="modal-footer">
            <woot-button :is-disabled="!selectedPlanId">
              {{ $t('CAMPAIGN_FLOW.QUOTATION.BUTTON') }}
            </woot-button>
            <woot-button variant="clear" @click.prevent="onClose">
              {{ $t('CAMPAIGN.ADD.CANCEL_BUTTON_TEXT') }}
            </woot-button>
          </div>
        </div>
      </form>
    </div>
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import QuotationTags from './QuotationTags.vue';

export default {
  components: { QuotationTags },
  props: {
    show: { type: Boolean, default: false },
    onClose: { type: Function, default: () => {} },
    clientId: { type: [String, Number], default: null },
    plateField: { type: String, default: '' },
    planId: { type: [String, Number], default: '' },
  },
  data() {
    return {
      selectedPlanId: this.planId || '',
      selectedPlateField: this.plateField || 'placa',
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({ plans: 'getPlanQuotations' }),
  },
  async mounted() {
    if (this.plans.length || !this.clientId) return;
    this.isLoading = true;
    await this.$store
      .dispatch('getPlanQuotationByCompany', this.clientId)
      .catch(() => null);
    this.isLoading = false;
  },
  methods: {
    onSave() {
      if (!this.selectedPlanId) return;
      const plan = this.plans.find(p => p.id === this.selectedPlanId);
      this.$emit('save', {
        plan_id: this.selectedPlanId,
        plan_name: plan?.nome,
        plate_field: this.selectedPlateField || 'placa',
      });
    },
  },
};
</script>

<style scoped>
.help-text {
  margin: -0.6rem 0 1.2rem;
  font-size: 1.2rem;
  color: #8a97a3;
}
.help-text.error {
  color: var(--r-500);
}
.modal-footer .button {
  margin-left: 0 !important;
}
</style>
